import React from 'react';
import Cat from './cat.svg';
import styles from './CatSvg.module.scss';

const CatSvg = () => (
  <div className={`${styles['a-cat-svg']}`} data-test="cat-svg">
    <Cat />
  </div>
);

export default CatSvg;
